import { createSlice } from '@reduxjs/toolkit';

// initial state
const initialState = {
	slides: [],
};

// active account slice
export const allSlidesSlice = createSlice({
	name: 'slides',
	initialState,
	reducers: {
		setAllSlides: (state, action) => {
			state.slides = action.payload;
		},
	},
});

export const {
	setAllSlides,
} = allSlidesSlice.actions;

export default allSlidesSlice.reducer;
